import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import PrettyContainer from "../../prettyContainer/PrettyContainer";
import { getAllApplications, setApplicationsUseAlternativeURL } from "../../../helpers/api";

const AZUL = "#3790ed";
const AZUL_OSCURO = "#1c6fc4";
const MUTED = "#6b7a90";
const ALLDATA_ID = 11;

export default function AllDataSourcePage() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [useAlt, setUseAlt] = useState(false); // false = usual (my.alldata.com), true = DiagMotor (datape)
  const [msg, setMsg] = useState({ type: "", text: "" });

  const cargar = () => {
    setLoading(true);
    getAllApplications()
      .then((res) => {
        const apps = Array.isArray(res) ? res : (res && res.applications) || [];
        const ad = apps.find((a) => Number(a.id) === ALLDATA_ID);
        setUseAlt(!!(ad && ad.useAlternative));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { cargar(); }, []);

  const cambiar = (nuevoUseAlt) => {
    if (nuevoUseAlt === useAlt || saving) return;
    setMsg({ type: "", text: "" });
    setSaving(true);
    setApplicationsUseAlternativeURL({ appId: ALLDATA_ID, useAlternative: nuevoUseAlt })
      .then(() => {
        setSaving(false);
        setUseAlt(nuevoUseAlt);
        setMsg({
          type: "success",
          text: nuevoUseAlt
            ? "AllData V2 now uses the DiagMotor source (datape)."
            : "AllData V2 now uses the usual account (my.alldata.com).",
        });
      })
      .catch(() => {
        setSaving(false);
        setMsg({ type: "warning", text: "Could not change the source. Please try again." });
      });
  };

  const opcion = (activo, titulo, sub, onClick) => (
    <button
      onClick={onClick}
      disabled={saving}
      style={{
        flex: 1, textAlign: "left", padding: "16px 18px", borderRadius: "14px",
        border: activo ? `2px solid ${AZUL}` : "2px solid #e6ebf2",
        background: activo ? "#eef4fd" : "#fff",
        cursor: saving ? "not-allowed" : "pointer", minWidth: 0,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontWeight: 800, color: "#1d2735" }}>{titulo}</span>
        {activo && (
          <span style={{ fontSize: "0.68rem", fontWeight: 700, letterSpacing: "0.05em", color: "#fff",
            background: AZUL, borderRadius: "999px", padding: "3px 10px" }}>IN USE</span>
        )}
      </div>
      <div style={{ color: MUTED, fontSize: "0.85rem", marginTop: "4px" }}>{sub}</div>
    </button>
  );

  return (
    <PrettyContainer tittle="ALLDATA SOURCE">
      <div style={{ paddingTop: "0.6em" }}>
        <p style={{ color: MUTED }}>
          Choose which AllData V2 access all clients use. If the usual one goes down (session
          killed), switch to the DiagMotor source. The change is instant for everyone.
        </p>
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px", color: MUTED }}>
            <Spinner animation="border" size="sm" /> Loading…
          </div>
        ) : (
          <>
            {msg.text && <Alert variant={msg.type}>{msg.text}</Alert>}
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              {opcion(!useAlt, "AllData (usual)",
                "my.alldata.com account. The real AllData. Default.", () => cambiar(false))}
              {opcion(useAlt, "DiagMotor AllData",
                "The obd2sw / datape source — stable backup, no session-kill issues.", () => cambiar(true))}
            </div>
            {saving && (
              <div style={{ color: MUTED, fontSize: "0.85rem", marginTop: "10px" }}>
                <Spinner animation="border" size="sm" /> Switching…
              </div>
            )}
          </>
        )}
      </div>
    </PrettyContainer>
  );
}
